// Every query key, in one place.
//
// Shared so the two apps cannot drift into invalidating different things —
// a mismatch that shows up as stale data on one platform only, which is
// miserable to track down.

export const portalKeys = {
  summary: ['portal-summary'] as const,
  payments: ['portal-payments'] as const,
  linkedTenants: ['portal-linked-tenants'] as const,
  config: (tenantId: string | undefined) => ['portal-config', tenantId] as const,
  invoices: (filters?: Record<string, unknown>) =>
    filters ? (['portal-invoices', filters] as const) : (['portal-invoices'] as const),
  invoice: (id: string | undefined) => ['portal-invoice', id] as const,
  invoiceLogs: (id: string | undefined) => ['portal-invoice-logs', id] as const,
};
